import { useState } from "react";
import { KeyRound, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogTrigger } from "../ui/dialog";
import { inputCls } from "../request/Field";
import { http, errMsg } from "../../lib/api";

const empty = { current_password: "", new_password: "", confirm: "" };

export const ChangePassword = () => {
  const [open, setOpen] = useState(false);
  const [f, setF] = useState(empty);
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setF((p) => ({ ...p, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    if (f.new_password.length < 8) return setErr("New password must be at least 8 characters");
    if (f.new_password !== f.confirm) return setErr("New passwords don't match");
    setBusy(true);
    setErr("");
    try {
      await http.post("/auth/change-password", { current_password: f.current_password, new_password: f.new_password });
      toast.success("Password changed");
      setF(empty);
      setOpen(false);
    } catch (e2) {
      setErr(errMsg(e2));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={(o) => { setOpen(o); setErr(""); setF(empty); }}>
      <DialogTrigger asChild>
        <button data-testid="admin-change-password-btn" className="inline-flex items-center gap-2 border border-white/10 px-3 py-2 text-sm hover:border-ember">
          <KeyRound className="h-4 w-4" /> <span className="hidden sm:inline">Password</span>
        </button>
      </DialogTrigger>
      <DialogContent className="border-white/10 bg-ink sm:max-w-md" data-testid="change-password-dialog">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl font-extrabold">Change password</DialogTitle>
          <DialogDescription className="text-slate-400">Use at least 8 characters.</DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-3">
          <input data-testid="current-password-input" type="password" required autoComplete="current-password" className={inputCls} placeholder="Current password" value={f.current_password} onChange={set("current_password")} />
          <input data-testid="new-password-input" type="password" required autoComplete="new-password" className={inputCls} placeholder="New password" value={f.new_password} onChange={set("new_password")} />
          <input data-testid="confirm-password-input" type="password" required autoComplete="new-password" className={inputCls} placeholder="Confirm new password" value={f.confirm} onChange={set("confirm")} />
          {err && <p data-testid="change-password-error" className="text-sm text-red-400">{err}</p>}
          <button data-testid="change-password-submit-btn" disabled={busy} className="inline-flex w-full items-center justify-center gap-2 bg-ember px-6 py-3.5 font-semibold text-ink hover:bg-amber-400 disabled:opacity-60">
            {busy && <Loader2 className="h-4 w-4 animate-spin" />} Update password
          </button>
        </form>
      </DialogContent>
    </Dialog>
  );
};
